import i18n from 'i18n';
import parsePhoneNumberFromString from 'libphonenumber-js';
import { object, string } from 'yup';

export const forgotPasswordSchema = object({
  email: string()
    .email(() => i18n.t('forgotPassword.email.errors.email'))
    .default(''),
  phone: string()
    .default('')
    .test(
      `test-phone`,
      () => i18n.t('forgotPassword.phone.errors.test-phone'),
      function (value) {
        return !value || parsePhoneNumberFromString(value, 'US')?.isPossible();
      },
    ),
}).test('email-or-phone', function (value) {
  const { email, phone } = value;
  if (Boolean(email || phone)) {
    return true;
  }

  return this.createError({
    path: 'email',
    message: i18n.t('forgotPassword.email.errors.email-or-phone'),
  });
});
